import React, { useState, useEffect } from 'react';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { AutoComplete } from 'antd';

import { BACKEND_CONFIG } from '../../config/consts';

import 'antd/dist/antd.min.css';

const MIN_INPUT_LENGTH = 3;

const Typeahead = ({ 'data-testid': dataTestId, onSelect, initVal, ...props }) => {
  const [allOptions, setAllOptions] = useState(null);
  const [options, setOptions] = useState(null);
  const [textValue, setTextValue] = useState('');

  const brandCode = BACKEND_CONFIG.get('brandCode');
  const busUnitId = BACKEND_CONFIG.get('busUnitId');

  const handleSearch = debounce(value => {
    if (value.length >= MIN_INPUT_LENGTH) {
      axios
        .request({
          url: `webcategoriestypeahead/${brandCode}/${busUnitId}/search?query=${encodeURIComponent(
            value,
          )}`,
          method: 'get',
          baseURL: '/api/primary_contentmanagement/',
        })
        .then(response => {
          setOptions(
            response.data.map(({ Id, Description }) => ({
              label: (
                <span data-testid="typeahead-text-label">{Description}</span>
              ),
              value: `${Id}|${Description}`,
            })),
          );
        });
    } else if (value.length > 0) {
      setOptions(null);
    } else {
      setOptions(allOptions);
    }
  }, 500);

  const handleChange = value => {
    setTextValue(value);
  };

  const handleSelect = (value, { label }) => {
    onSelect(value);

    setTextValue(label.props.children);
  };

  useEffect(() => {
    axios
      .request({
        url: `webcategoriesbybrandcode/${brandCode}/${busUnitId}/all`,
        method: 'get',
        baseURL: '/api/primary_contentmanagement/',
      })
      .then(response => {
        const allOptionsData = response.data.map(({ Id, Description }) => ({
          label: <span data-testid="typeahead-text-label">{Description}</span>,
          value: `${Id}|${Description}`,
        }));

        setAllOptions(allOptionsData);
        setOptions(allOptionsData);
      });
  }, [brandCode, busUnitId]);

  return (
    <div style={{ xminHeight: 220 }}>
      <AutoComplete
        options={options}
        value={textValue}
        getPopupContainer={trigger => trigger.parentElement}
        style={{ display: 'block' }}
        notFoundContent={
          options && options.length === 0 ? 'No matches found' : undefined
        }
        onChange={handleChange}
        onSearch={handleSearch}
        onSelect={handleSelect}
        {...props}
      >
        <input
          data-testid={dataTestId}
          className="form-control"
          style={{ height: 44 }}
          placeholder={initVal}
        />
      </AutoComplete>
    </div>
  );
};

export default Typeahead;
